<template>
  <div class="search">
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :words="keyWords" :showHot="true" type="shop" @getList="getSearch"></top-search>
    </div>
    <!-- <div class="h-top"></div> -->

    <div class="search-content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>搜索</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-title" v-if="keyWords">
        <div class="line-h" v-if="loading">
          <el-skeleton animated>
            <template slot="template">
              <el-skeleton-item variant="text" style="width: 40%; height: 30px;"/>
            </template>
          </el-skeleton>
        </div>
        <div v-else>
          共搜索到<span class="color-blue">“{{ keyWords }}”</span>{{ total }} 个结果
        </div>
      </div>

      <div>

        <div class="loading-style search-list"  v-if="loading" >
          <div class="search-item">
            <el-skeleton animated>
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 240px; height: 240px;margin-right: 50px;"/>
              </template>
            </el-skeleton>
            <div class="right-content">
              <el-skeleton animated>
                <template slot="template">
                  <div style="display: flex;justify-content: space-between;">
                    <el-skeleton-item variant="text" style="width: 30%;height: 40px;"/>
                    <el-skeleton-item variant="text" style="width: 20%;height: 40px;"/>
                  </div>
                  <div style="padding:10px 0">
                    <el-skeleton-item variant="text" style="width: 100px;height: 30px;"/>
                  </div>
                  <el-skeleton-item variant="text" style="width: 100%;height: 150px;"/>
                </template>
              </el-skeleton>
            </div>
          </div>
        </div>
        <template v-else>
          <div class="search-list">
            <div class="search-item" v-for="item in list" :key="item.id">
              <div class="left-image">
                <img :src="item.image" alt="商品图片"/>
              </div>
              <div class="right-content">
                <div class="top-inner">
                  <div class="name-box">
                    <div class="name-box-name">{{ item.name || "--" }}</div>
                    <el-tag @click="copyCas(item.cas_no)">
                      CAS:{{ item.cas_no }}
                      <i class="el-icon-document-copy"></i>
                    </el-tag>
                  </div>
                  <div class="button-box">
                    <!--                     <el-button type="primary" plain>历史报价</el-button>-->
                    <gradient-button background="#ECF5FF" color="#387DF6" @hit="handleHistory(item)">历史报价
                    </gradient-button>
                    <gradient-button background="#387DF6" @hit="goDetail(item.id)">查看详情</gradient-button>
                  </div>
                </div>
                <div class="bottom-inner">
                  <table class="custom-table">
                    <tr>
                      <td>中文名</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.name || "--" }}
                        </div>
                      </td>
                      <td>英文名</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.name_en || "--" }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>中文别名</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.alias_name || "--" }}
                        </div>
                      </td>
                      <td>英文别名</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.alias_name_en || "--" }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>分子式</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.fenzishi || "--" }}
                        </div>
                      </td>
                      <td>分子量</td>
                      <td>
                        <div class="ellipsis">
                          {{ item.fenziliang || "--" }}
                        </div>
                      </td>
                    </tr>
                  </table>
                  <el-tag type="danger" v-if="item.is_danger == 1">危化产品</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="padding-b-40">
            <empty v-if="list.length === 0"></empty>
          </div>
          <div v-if="list.length>10" class="pagination-box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                           :page-sizes="[10, 50, 100, 200]" :page-size="limit" background
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </template>
      </div>
    </div>
    <!-- 历史报价弹窗 -->
    <history :historyDialog.sync="historyDialog" :detailInfo="detailInfo" @upDateState="handleHistoryClose"></history>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeTop from "@/components/public/home-top.vue";
import TopSearch from "@/components/public/top-search.vue";
import Navicat from "@/components/navicat/navicat.vue";
import {search} from "@/api/modules/common";
import GradientButton from "@/components/button/gradient-button.vue";
import Empty from "@/components/public/empty.vue";
import HomeFooter from "../../components/public/home-footer.vue";
import history from "@/components/dialog/history.vue";

export default {
  name: "search-page",
  components: {
    history,
    HomeFooter,
    HomeTop,
    TopSearch,
    Navicat,
    GradientButton,
    Empty,
  },
  data() {
    return {
      detailInfo: {},
      historyDialog: false,
      keyWords: this.$route.query.keyWords,
      total: 0,
      list: [],
      page: 1,
      limit: 10,
      loading: true,
      // 防抖与节流控制
      _debounceTimer: null,
      _throttleLock: false,
      _throttleTimer: null,
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin;
    },
  },
  mounted() {
    if (this.keyWords) {
      if (this.keyWords.trim()) {
        this.getSearch();
      }
    }
  },
  methods: {
    // 历史报价弹窗
    handleHistory(item) {
      this.historyDialog = true;
      this.detailInfo = item;
    },
    // 关闭历史报价弹窗
    handleHistoryClose(state) {
      this.historyDialog = state;
    },
    copyCas(inner) {
      if (inner) {
        navigator.clipboard
            .writeText(inner)
            .then(() => {
              this.$message.success({
                message: "已复制到剪贴板",
                duration: 2000,
                offset: 200,
              });
            })
            .catch(() => {
              // 降级方案
              const textArea = document.createElement("textarea");
              textArea.value = inner;
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand("copy");
              document.body.removeChild(textArea);
              this.$message.success({
                message: "已复制到剪贴板",
                duration: 2000,
                offset: 200,
              });
            });
      }
    },
    // 对外暴露：防抖搜索入口（模板与其他调用不需要改动）
    getSearch(key) {
      if (typeof key !== 'undefined') {
        this.keyWords = key
      }
      if (this._debounceTimer) {
        clearTimeout(this._debounceTimer)
        this._debounceTimer = null
      }
      this._debounceTimer = setTimeout(() => {
        this._debounceTimer = null
        this.doSearch()
      }, 300)
    },

    // 实际发起请求的方法（请求体保持不变）
    async doSearch() {
      const kw = (this.keyWords || '').trim()
      if (!kw) {
        this.list = []
        this.total = 0
        this.loading = false
        return
      }
      this.loading = true;
      let res = await search({
        keywords: kw,
        page: this.page,
        limit: this.limit,
      });
      this.list = res.data.data.data;
      this.total = res.data.data.total;
      this.loading = false;
    },
    // 分页使用节流，避免短时间内触发多次请求
    handleSizeChange(val) {
      this.limit = val;
      if (this._throttleLock) return
      this._throttleLock = true
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.doSearch()
      this._throttleTimer && clearTimeout(this._throttleTimer)
      this._throttleTimer = setTimeout(() => {
        this._throttleLock = false
      }, 600)
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this._throttleLock) return
      this._throttleLock = true
      this.doSearch()
      this._throttleTimer && clearTimeout(this._throttleTimer)
      this._throttleTimer = setTimeout(() => {
        this._throttleLock = false
      }, 600)
    },
    goDetail(id) {

      this.$router.push({
        path: "/search",
        query: {id},
      });

    },
  },
};
</script>
<style lang="scss">
.button-box {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
}

.line-h {
  padding-top: 8px;
}


.loading-style {

  .right-content {
    flex: 1;
  }

}


.h-top {
  height: 185px;
  //height: 223px;
}

.bread-crumb {
  margin-top: 20px;
}

.search-content {
  .search-title {
    margin: 20px 0;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    line-height: 50px;
    padding: 0 50px;
    box-sizing: border-box;
    color: #00112b;
    font-weight: 600;

    .color-blue {
      color: #4b87ff;
    }
  }

  .padding-b-40 {
    padding-bottom: 80px;
  }

  .search-list {

    .search-item {
      display: flex;
      padding: 50px;
      background: #ffffff;
      margin-bottom: 20px;

      .left-image {
        border: 1px solid #d8d8d8;
        width: 240px;
        height: 240px;
        margin-right: 50px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .right-content {
        flex: 1;

        .top-inner {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .name-box {
            font-weight: 800;
            font-size: 18px;
            color: #00112b;

            .name-box-name {
              margin-bottom: 10px;
            }
          }
        }

        .bottom-inner {
          padding-top: 10px;

          .custom-table {
            width: 100%;
            margin-bottom: 10px;
            border-collapse: collapse;
            /* 关键：合并边框 */
            // border-color: #f3f3f3;


            /* 新增样式规则 */
            td:nth-child(1),
            td:nth-child(3) {
              width: 179px;
              min-height: 60px;
              background: #f9faff;
              text-align: right;
              padding-right: 43px;
              color: #5f616c;
              box-sizing: border-box;
              border: 1px solid #eaeefb;

            }

            td:nth-child(2),
            td:nth-child(4) {
              min-height: 60px;
              padding: 10px;
              // line-height: 60px;
              border-top: 1px solid #eaeefb;
              border-bottom: 1px solid #eaeefb;
              width: 300px;
              color: #00112b;
              word-break: break-all;
              /* 允许在任意字符处断开 */
              word-wrap: break-word;
              /* 允许在单词内断开 */
            }
          }
        }
      }
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    margin-bottom: 40px;
  }
}
</style>
